import {NgModule, APP_INITIALIZER, LOCALE_ID} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';

import {SharedModule} from '@shared/shared.module';
import {ModalModule} from 'ngx-bootstrap/modal';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {RootRoutingModule} from './root-routing.module';
import {API_BASE_URL} from '@shared/service-proxies/service-proxies';

import {RootComponent} from './root.component';
import {AppInitializer} from './app-initializer';
import {ServiceProxyModule} from '@shared/service-proxies/service-proxy.module';
import {CustomAbpHttpInterceptor} from '@shared/common/session/custom-abp-http-interceptor';
import {BypassedServiceProxyModule} from '@shared/bypassed-service-proxies/bypassed-proxies.module';
import {ENVIRONMENT} from "@shared/utils/environment";
import {getEnvironment} from "@shared/utils/environment-factory";

export function getCurrentLanguage(): string {
    if (abp.localization.currentLanguage.name) {
        return abp.localization.currentLanguage.name;
    }
    // todo: Waiting for https://github.com/angular/angular/issues/31465 to be fixed.
    return 'en';
}

/*
 * I have to use a string here instead of the Environment instance because ABP auto generates the file that uses it.
 */
export function getBackendUrl(): string {
    const {backendUrl} = getEnvironment();
    return backendUrl;
}

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedModule.forRoot(),
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        TabsModule.forRoot(),
        ServiceProxyModule,
        RootRoutingModule,
        BypassedServiceProxyModule
    ],
    declarations: [RootComponent],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: CustomAbpHttpInterceptor, multi: true},
        {
            provide: APP_INITIALIZER,
            useFactory: (appInitializer: AppInitializer) => appInitializer.init(),
            deps: [AppInitializer],
            multi: true,
        },
        {provide: API_BASE_URL, useFactory: getBackendUrl},
        {provide: ENVIRONMENT, useFactory: getEnvironment},
        {
            provide: LOCALE_ID,
            useFactory: getCurrentLanguage,
        },
        {provide: 'googleTagManagerId', useValue: "GTM-M296G4S"}
    ],
    bootstrap: [RootComponent],
})
export class RootModule {
}
